var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class, _class2, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { tagName, layout as templateLayout } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
import { action, computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import { A } from '@ember/array';
import Component from '@ember/component';
import { isNone, isEmpty, isBlank } from '@ember/utils';
import layout from '../templates/components/fly-autocomplete-input';
import { DOWN, ENTER, ESCAPE, UP } from '@customerio/fly-components/utils/keyboard-support';
import itemProperty from '@customerio/fly-components/utils/item-property';
import { errorsArrayToString, ErrorType } from '@customerio/fly-components/utils/errors';

// We limit the `visibleItems` to 100
const ITEM_LIMIT = 100;
let FlyAutocompleteInput = (_dec = tagName(''), _dec2 = templateLayout(layout), _dec3 = equal('size', 'sm'), _dec4 = computed('hasMoreItems', 'unavailableItemCount'), _dec5 = computed('errors.[]'), _dec6 = computed('filteredItems.[]'), _dec7 = computed('moreItems', 'items.[]', 'value', 'showAllItems'), _dec8 = computed('items.length', 'totalItems'), _dec9 = computed('items.[]', 'filteredItems.[]', 'visibleItems.[]', 'moreItems', 'value'), _dec10 = observes('value'), _dec11 = observes('visibleItems.[]'), _dec12 = computed('isOpen', 'visibleItems.length'), _dec13 = computed('isDropdownVisible', 'visibleItems.length'), _dec14 = computed('isClearable', 'value'), _dec15 = computed('isOpen', 'errors.length'), _dec16 = computed('showErrors', 'errorType'), _dec17 = computed('showErrors', 'errorType'), _dec(_class = _dec2(_class = (_class2 = class FlyAutocompleteInput extends Component {
  constructor(...args) {
    super(...args);
    // External API
    _defineProperty(this, "items", []);
    _defineProperty(this, "hasMoreItems", false);
    _defineProperty(this, "totalItems", null);
    // you can pass in either `hasMoreItems` or `totalItems`
    _defineProperty(this, "placeholder", null);
    _defineProperty(this, "value", null);
    _defineProperty(this, "inputTabindex", null);
    _defineProperty(this, "errors", []);
    _defineProperty(this, "errorType", ErrorType.Tooltip);
    _defineProperty(this, "controlGroupClassNames", null);
    _defineProperty(this, "inputClassNames", 'fly-form-control');
    _defineProperty(this, "renderInPlace", true);
    _defineProperty(this, "isDropdownVisible", true);
    _defineProperty(this, "isDisabled", false);
    _defineProperty(this, "isClearable", false);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "inputId", null);
    _defineProperty(this, "size", '');
    // Internal state
    _defineProperty(this, "focusedItem", null);
    _defineProperty(this, "isOpen", false);
    _defineProperty(this, "showAllItems", false);
    _initializerDefineProperty(this, "isSmall", _descriptor, this);
  }
  onInput() {}
  // `moreItems` is used to decide whether to include a message in the `Use` label
  // about the items being limited to your first {{items.length}}
  get moreItems() {
    return this.unavailableItemCount > 0 || this.hasMoreItems;
  }
  get errorMessage() {
    if (isEmpty(this.errors)) {
      return '';
    }
    return errorsArrayToString(this.errors);
  }
  get visibleItems() {
    let {
      filteredItems
    } = this;
    if (isNone(filteredItems)) {
      return;
    }
    return A(filteredItems.slice(0, ITEM_LIMIT));
  }
  get filteredItems() {
    let {
      value,
      items
    } = this.getProperties('value', 'items');
    if (this.showAllItems || isBlank(value)) {
      return items;
    }
    if (isEmpty(items)) {
      return items;
    }
    let query = value.trim().toLowerCase();
    let filtered = items.filter(item => item.toLowerCase().indexOf(query) >= 0);
    if (!filtered.some(item => item === value)) {
      let label = `Use "${value}"`;
      if (this.moreItems) {
        label = `${label} (searching your first ${this.items?.length.toLocaleString()})`;
      }

      // Notice we add this extra item to the filteredItems,
      // so we have to make sure to decrement the count of filteredItems by 1
      // before we report how many items are in the dropdown,
      // since the `Use` label doesn't count as an item
      filtered.unshift({
        label,
        value
      });
    }
    return A(filtered);
  }
  get unavailableItemCount() {
    let available = this.items?.length;
    let {
      totalItems
    } = this;
    if (isNone(totalItems)) {
      return;
    }
    return totalItems - available;
  }
  get trailer() {
    let filtered = this.filteredItems?.length;
    if (this.filteredItems?.[0]?.label) {
      // If the first object is the Use item that we sometimes add to the filteredItems,
      // decrement the count by 1, since it's not a real item
      filtered--;
    }
    let visible = this.visibleItems?.length;
    if (filtered > visible) {
      let trailerText = `Showing ${visible.toLocaleString()} of ${filtered.toLocaleString()}`;
      if (this.moreItems && this.items.length === filtered) {
        // If the autocomplete includes the full list,
        // and we know the full list has unavailable items,
        // include a + at the end of the count
        // For example: "Showing 100 of of 2,000+ items"
        // In this case, saying 2,000+ is more accurate than saying 2,000
        trailerText += '+';
      }
      if (this.value) {
        trailerText += '. Please refine your search.';
      } else {
        trailerText += '. Start your search.';
      }
      return trailerText;
    }
    return;
  }
  _valueObserver() {
    this.set('showAllItems', false);
  }
  _focusedItemObserver() {
    this._focusMatchingItem();
  }
  _focusMatchingItem() {
    let {
      value,
      visibleItems
    } = this.getProperties('value', 'visibleItems');
    let focusedItem;
    if (isBlank(value) || isNone(visibleItems)) {
      focusedItem = null;
    } else if (visibleItems.indexOf(value) !== -1) {
      focusedItem = value;
    } else {
      focusedItem = visibleItems[0];
    }
    this.set('focusedItem', focusedItem);
  }
  get showDropdownMenu() {
    let {
      isOpen
    } = this;
    return isOpen && this.visibleItems?.length > 0;
  }
  get showDropdownButton() {
    return this.isDropdownVisible && this.visibleItems?.length > 0;
  }
  get showClear() {
    return this.isClearable && !isEmpty(this.value);
  }
  get showErrors() {
    return !this.isOpen && this.errors?.length > 0;
  }
  get showErrorMessage() {
    return this.showErrors && this.errorType === ErrorType.Message;
  }
  get showErrorTooltip() {
    return this.showErrors && this.errorType === ErrorType.Tooltip;
  }
  _hideMenu() {
    this.setProperties({
      focusedItem: null,
      showAllItems: false,
      isOpen: false
    });
  }
  _toggleSelection(item) {
    let value = itemProperty(item, 'value');
    this.onInput(value);
    this.setProperties({
      value,
      showAllItems: false,
      isOpen: false
    });
  }
  onInputAction(event) {
    this.onInput(event.target.value);
  }
  showMenu() {
    this.set('isOpen', true);
    this._focusMatchingItem();
  }
  clearValue() {
    this.set('value', '');
  }
  didInsertInput(inputElement) {
    this.inputElement = inputElement;
  }
  showAllItemsAction() {
    this.set('showAllItems', true);
    if (this.inputElement == null) {
      return;
    }
    this.inputElement.focus();
    this.inputElement.select();
    this.set('isOpen', true);
    this._focusMatchingItem();
  }
  hideMenu() {
    this._hideMenu();
  }
  toggleSelection(item) {
    this._toggleSelection(item);
  }
  focusItem(item) {
    this.set('focusedItem', item);
  }
  navigateFocus(event) {
    let key = event.which;
    if (key === DOWN || key === UP) {
      this.set('isOpen', true);
      event.preventDefault();
      let currentFocus = this.focusedItem;
      if (!currentFocus) {
        this.set('focusedItem', this.visibleItems?.[0]);
        return;
      }
      let items = this.visibleItems;
      let currentFocusIndex = items.indexOf(currentFocus);
      let delta = key === DOWN ? +1 : -1;
      let item = items[currentFocusIndex + delta];
      if (!isNone(item)) {
        this.set('focusedItem', item);
      }
    } else if (key === ENTER) {
      if (this.showDropdownMenu) {
        this._toggleSelection(this.focusedItem);
      }
    } else if (key === ESCAPE) {
      this._hideMenu();
    } else {
      this.set('isOpen', true);
    }
  }
  findDropdown() {
    return this.inputElement;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "isSmall", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "moreItems", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "moreItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "errorMessage", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "errorMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "visibleItems", [_dec6], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "filteredItems", [_dec7], Object.getOwnPropertyDescriptor(_class2.prototype, "filteredItems"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "unavailableItemCount", [_dec8], Object.getOwnPropertyDescriptor(_class2.prototype, "unavailableItemCount"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "trailer", [_dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "trailer"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_valueObserver", [_dec10], Object.getOwnPropertyDescriptor(_class2.prototype, "_valueObserver"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "_focusedItemObserver", [_dec11], Object.getOwnPropertyDescriptor(_class2.prototype, "_focusedItemObserver"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDropdownMenu", [_dec12], Object.getOwnPropertyDescriptor(_class2.prototype, "showDropdownMenu"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showDropdownButton", [_dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "showDropdownButton"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showClear", [_dec14], Object.getOwnPropertyDescriptor(_class2.prototype, "showClear"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showErrors", [_dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "showErrors"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showErrorMessage", [_dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "showErrorMessage"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showErrorTooltip", [_dec17], Object.getOwnPropertyDescriptor(_class2.prototype, "showErrorTooltip"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onInputAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onInputAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showMenu", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "showMenu"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "clearValue", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "clearValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "didInsertInput", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "didInsertInput"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showAllItemsAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "showAllItemsAction"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hideMenu", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "hideMenu"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "toggleSelection", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleSelection"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "focusItem", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "focusItem"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "navigateFocus", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "navigateFocus"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "findDropdown", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "findDropdown"), _class2.prototype)), _class2)) || _class) || _class);
export { FlyAutocompleteInput as default };